/* eslint-disable react-hooks/rules-of-hooks */

import React from 'react'
import useEffectDebounced from './useEffectDebounced'

/**
 * Return a value that update when provided argument stop updating (debounced)
 * @param {*} value - the value to debounce
 * @param {Number} timeout - number of milliseconds used to debounce the reevaluation
 * @param {Object} options - options for the lodash debounce method
 */
const useDebouncedValue = (timeout, options) => value => {
  // initialize debounced value state
  const [debouncedValue, setDebouncedValue] = React.useState(value)

  // update debouncedValue when value changes with a debounced effect
  useEffectDebounced(timeout, options)(() => setDebouncedValue(value), [value])

  // return the debounced value
  return debouncedValue
}

export default useDebouncedValue
